var _polygon, _polygon2, _polygon3, _rect, _polygon4, _polygon5, _polygon6, _rect2, _g, _rect3, _path, _circle, _circle2, _circle3, _g2, _g3, _circle4, _circle5, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Searchprocessor",
    x: 0,
    y: 0,
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#525252",
    points: "43.19 19.47 42.01 19.47 42.01 11.31 45.96 7.36 45.96 3.25 47.15 3.25 47.15 7.85 43.19 11.8",
    className: "color3a556a svgShape"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#525252",
    points: "29.74 19.47 28.55 19.47 28.55 11.8 24.59 7.85 24.59 3.25 25.78 3.25 25.78 7.36 29.74 11.31",
    className: "color3a556a svgShape"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#525252",
    points: "23.8 19.47 22.61 19.47 22.61 11.8 18.66 7.85 18.66 3.25 19.84 3.25 19.84 7.36 23.8 11.31",
    className: "color3a556a svgShape"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.19,
    height: 16.22,
    x: 35.28,
    y: 3.25,
    fill: "#525252",
    className: "color3a556a svgShape"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#525252",
    points: "47.15 60.93 45.96 60.93 45.96 56.82 42.01 52.86 42.01 44.7 43.19 44.7 43.19 52.37 47.15 56.33",
    className: "color3a556a svgShape"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#525252",
    points: "25.78 60.93 24.59 60.93 24.59 56.33 28.55 52.37 28.55 44.7 29.74 44.7 29.74 52.86 25.78 56.82",
    className: "color3a556a svgShape"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#525252",
    points: "19.84 60.93 18.66 60.93 18.66 56.33 22.61 52.37 22.61 44.7 23.8 44.7 23.8 52.86 19.84 56.82",
    className: "color3a556a svgShape"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.19,
    height: 16.22,
    x: 35.28,
    y: 44.7,
    fill: "#525252",
    className: "color3a556a svgShape"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#525252",
    points: "53.92 23.06 45.77 23.06 45.77 21.87 53.44 21.87 57.39 17.94 61.99 17.94 61.99 19.13 57.88 19.13",
    className: "color3a556a svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#525252",
    points: "61.99 30.78 57.39 30.78 53.44 26.85 45.77 26.85 45.77 25.67 53.92 25.67 57.88 29.6 61.99 29.6",
    className: "color3a556a svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#525252",
    points: "61.99 46.23 57.39 46.23 53.44 42.31 45.77 42.31 45.77 41.12 53.92 41.12 57.88 45.05 61.99 45.05",
    className: "color3a556a svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.22,
    height: 1.19,
    x: 45.77,
    y: 35.36,
    fill: "#525252",
    className: "color3a556a svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#525252",
    points: "20.04 23.06 11.88 23.06 7.93 19.13 3.82 19.13 3.82 17.94 8.42 17.94 12.37 21.87 20.04 21.87",
    className: "color3a556a svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#525252",
    points: "8.42 30.78 3.82 30.78 3.82 29.6 7.93 29.6 11.88 25.67 20.04 25.67 20.04 26.85 12.37 26.85",
    className: "color3a556a svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#525252",
    points: "8.42 46.23 3.82 46.23 3.82 45.05 7.93 45.05 11.88 41.12 20.04 41.12 20.04 42.31 12.37 42.31",
    className: "color3a556a svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.22,
    height: 1.19,
    x: 3.82,
    y: 35.36,
    fill: "#525252",
    className: "color3a556a svgShape"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 31.49,
    height: 31.49,
    x: 17.16,
    y: 16.34,
    fill: "#9e9e9e",
    className: "color4bc8f1 svgShape"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e4e4e4",
    d: "M46.16,45.34H19.65V18.83h17.34c0,5.07,4.11,9.17,9.17,9.17V45.34z",
    className: "colore1e3e8 svgShape"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.77,
    cy: 40.39,
    r: 1.98,
    fill: "#ffffff",
    className: "colorebf0f3 svgShape"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.77,
    cy: 18.42,
    r: 1.98,
    fill: "#8c8c8c",
    className: "color3ebedb svgShape"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.77,
    cy: 29.9,
    r: 1.98,
    fill: "#8c8c8c",
    className: "color3ebedb svgShape"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.7,
    cy: 18.42,
    r: 1.98,
    fill: "#9e9e9e",
    className: "color4bc8f1 svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.7,
    cy: 29.9,
    r: 1.98,
    fill: "#9e9e9e",
    className: "color4bc8f1 svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.7,
    cy: 35.84,
    r: 1.98,
    fill: "#9e9e9e",
    className: "color4bc8f1 svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.7,
    cy: 45.33,
    r: 1.98,
    fill: "#9e9e9e",
    className: "color4bc8f1 svgShape"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.34,
    cy: 3.49,
    r: 1.98,
    fill: "#959595",
    className: "colorf2384e svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.05,
    cy: 3.49,
    r: 1.98,
    fill: "#959595",
    className: "colorf2384e svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.03,
    cy: 3.49,
    r: 1.98,
    fill: "#959595",
    className: "colorf2384e svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.37,
    cy: 3.49,
    r: 1.98,
    fill: "#959595",
    className: "colorf2384e svgShape"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.77,
    cy: 36.23,
    r: 1.98,
    fill: "#8c8c8c",
    className: "color3ebedb svgShape"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.77,
    cy: 45.73,
    r: 1.98,
    fill: "#8c8c8c",
    className: "color3ebedb svgShape"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.34,
    cy: 60.77,
    r: 1.98,
    fill: "#959595",
    className: "colorf2384e svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.66,
    cy: 60.77,
    r: 1.98,
    fill: "#959595",
    className: "colorf2384e svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.37,
    cy: 60.77,
    r: 1.98,
    fill: "#959595",
    className: "colorf2384e svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.43,
    cy: 60.77,
    r: 1.98,
    fill: "#959595",
    className: "colorf2384e svgShape"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.44,
    height: 3.79,
    x: 8.11,
    y: 52.58,
    fill: "#606060",
    transform: "rotate(48.792 8.83 54.474)",
    className: "color02bf96 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6e6e6e",
    d: "M9.48,56.06c-0.06,0.13-0.14,0.26-0.26,0.36L2.9,61.95c-0.39,0.34-0.99,0.31-1.33-0.09l-1.09-1.24 c-0.07-0.08-0.12-0.17-0.16-0.26C0.17,60,0.26,59.57,0.57,59.29l6.32-5.54c0.39-0.34,0.99-0.3,1.34,0.09l1.08,1.24 C9.55,55.36,9.6,55.74,9.48,56.06z",
    className: "color00dcab svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6e6e6e",
    d: "M22.75,54.44c-3.8,3.33-9.58,2.94-12.9-0.86c-3.33-3.8-2.94-9.58,0.86-12.9c3.8-3.33,9.58-2.94,12.9,0.86 C26.93,45.33,26.55,51.11,22.75,54.44z",
    className: "color00dcab svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eeeeee",
    d: "M21.53,53.04c-3.03,2.65-7.64,2.35-10.29-0.68c-2.65-3.03-2.35-7.64,0.68-10.29 c3.03-2.65,7.64-2.35,10.29,0.68C24.86,45.78,24.56,50.39,21.53,53.04z",
    className: "colorecf0f1 svgShape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIa);
export default __webpack_public_path__ + "static/media/ia.f45c363dd5b3e9dcd553aeb0b1d1495b.svg";
export { ForwardRef as ReactComponent };